import { SERVER_FORMAT_DATE_LONG } from 'core/constants';
import { formatDateForServer } from 'core/utils';
import { ICustomerQuote } from 'quotes/types';

import { IUpdateQuotesForm } from './types';

export const mapUpdateQuotesForm = (quotes: ICustomerQuote[], data: IUpdateQuotesForm) => {
  const quoteData = {
    closeConfidence: data?.closeConfidence,
    status: data?.status,
    statusNotes: {
      lost: data?.quoteStatusLostNote,
    },
    ...(data?.closeDate ? { estimatedCloseDate: data?.closeDate } : {}),
    verticalMarketId: data?.verticalMarket?.id,
    startDate: formatDateForServer(data?.validSince?.toString(), SERVER_FORMAT_DATE_LONG),
    validUntil: formatDateForServer(data?.validUntil?.toString(), SERVER_FORMAT_DATE_LONG),
  };

  return {
    quotes: quotes.map((quote) => ({
      id: quote.id,
      ...quoteData,
    })),
  };
};
